/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Contact<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  sendMessage = (data: { name?: string; email: string; message: string; isConsultation?: boolean; utmSource?: string; utmMedium?: string; utmCampaign?: string; utmContent?: string; utmTerm?: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Contact/Message`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
